import { render, staticRenderFns } from "./FormInputValidateTooltips.vue?vue&type=template&id=640ea558"
import script from "./FormInputValidateTooltips.vue?vue&type=script&lang=js"
export * from "./FormInputValidateTooltips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports